import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const DemoModal = props => (
  <Box
    height={0}
    pb="56.25%"
    position="relative"
  >
    <iframe
      allowFullScreen
      mozallowfullscreen
      webkitallowfullscreen
      frameBorder="0"
      height="100%"
      src="https://pins-marketing.s3.us-west-2.amazonaws.com/pins_ai_marketing_video.mp4"
      style={{ left: 0, position: 'absolute', top: 0 }}
      title="PINS AI Assistant Demo Video"
      width="100%"
    />
  </Box>
);

DemoModal.propTypes = {};

export default DemoModal;
